import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { signIn, register } from "../API/auth";
import {
  addMenu,
  updateMenu,
  getAllMenu,
  deleteMenu,

  getCategory,
  addCategory,
  updateCategory,
  deleteCategory,
  getAllVegetables,
  addVegetable,
  deleteVegetable,
  updateVegetable,
  getAllGrocery,
  addGrocery,
  deleteGrocery,
  updateGrocery,
  getAllDairyItems,
  addDairyItems,
  deleteDairyItems,
  updateDairyItems,
  getAllFarsanItems,
  addFarsanItems,
  deleteFarsanItems,
  updateFarsanItems,
  updateVasanItems,
  deleteVasanItems,
  addVasanItems,
  getAllVasanItems,
  getAllMiscellaneousItems,
  addMiscellaneousItems,
  updateMiscellaneousItems,
  deleteMiscellaneousItems,
  getHtmlContent,
  getOrderhtml,
  getGetBillhtml,
  updateMaterialData,
  updateSortOrderAll
} from "../API/menu";

import { addFarm, deleteFarm, getFarms, updateFarm } from '../API/farm';

import { addOrder, addOrderDetails, deleteOrder, getAllOrder, updateOrder, updateOrderDetails } from '../API/order'
import { useDispatch } from "react-redux";
import { createCaterer, getCatererById, updateCaterer } from "../API/caterers";
import { createSubscription } from "../API/subscription";
import { updateUserOnboardingStatus, getAllAdmin, updateUserLanguage } from "../API/users";
import { useState, useEffect } from "react";
import { getDashboardData } from "../API/dashboardApi";
import { createSettings, getSettings, updateSettings } from "../API/settings";

export const useSignIn = () => {
  return useMutation({
    mutationFn: (data) => signIn(data),
  });
};

// New: fetch all admins (owners)
export const useGetAllAdmin = () => {
  return useQuery({
    queryKey: ["All_Admin"],
    queryFn: () => getAllAdmin(),
    select: (response) => {
      const { data } = response;
      return data?.admins || [];
    },
  });
};


export const useGetAllMenu = () => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ["All_menu"],
    queryFn: () => getAllMenu(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },

  });
};


export const useDeleteMenu = () => {
  return useMutation({
    mutationFn: (payload) => deleteMenu(payload),
  });
};

export const useAddMenu = () => {
  return useMutation({
    mutationFn: (payload) => addMenu(payload)
  });
};

export const useUpdateMenu = () => {
  return useMutation({
    mutationFn: (payload) => updateMenu(payload),
  });
};


//Order 

export const useGetAllOrder = ({ startDate, endDate, selectedStatus, searchText }, options = {}) => {

  return useQuery({
    queryKey: ["All_Order", startDate, endDate, selectedStatus, searchText],
    queryFn: () => getAllOrder({ startDate, endDate, selectedStatus, searchText }),
    enabled: options.enabled ?? true,
    select: (response) => {
      const { data } = response;
      return data?.data;
    }
  });
};

export const useAddOrder = () => {
  return useMutation({
    mutationFn: (payload) => addOrder(payload),
  });
};

export const useGetHtmlContent = () => {
  return useMutation({
    mutationFn: (payload) => getHtmlContent(payload),
  });
}

export const useUpdateMaterialData = () => {
  return useMutation({
    mutationFn: (payload) => updateMaterialData(payload),
  });
}

export const useGetOrderhtml = () => {
  return useMutation({
    mutationFn: (payload) => getOrderhtml(payload),
  });
}

export const useGetBillhtml = () => {
  return useMutation({
    mutationFn: (payload) => getGetBillhtml(payload),
  });
}

export const useDeleteOrder = () => {
  return useMutation({
    mutationFn: (payload) => deleteOrder(payload),
  });
};

export const useUpdateOrder = () => {
  return useMutation({
    mutationFn: (payload) => updateOrder(payload),
  });
};


// Order Detailsexport 
export const useAddOrderDetails = () => {
  return useMutation({
    mutationFn: (payload) => addOrderDetails(payload),
  });
};


export const useUpdateOrderDetails = () => {
  return useMutation({
    mutationFn: (payload) => updateOrderDetails(payload),
  });
};



// Category
export const useGetAllCategory = () => {
  return useQuery({
    queryKey: ["All_Category"],
    queryFn: () => getCategory(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    }
  });
};

export const useAddCategory = () => {
  return useMutation({
    mutationFn: (payload) => addCategory(payload),
  });
};

export const useUpdateCategory = () => {
  return useMutation({
    mutationFn: (payload) => updateCategory(payload),
  });
};

export const useUpdateSortOrderAll = () => {
  return useMutation({
    mutationFn: (payload) => updateSortOrderAll(payload),
  });
};

export const useDeleteCategory = () => {
  return useMutation({
    mutationFn: (payload) => deleteCategory(payload),
  });
};

// vegetable

export const useGetAllVegetables = () => {
  return useQuery({
    queryKey: ["All_vegetable"],
    queryFn: () => getAllVegetables(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },

  });
};

export const useAddVegetable = () => {
  return useMutation({
    mutationFn: (payload) => addVegetable(payload),
  });
};

export const useDeleteVegetable = () => {
  return useMutation({
    mutationFn: (payload) => deleteVegetable(payload),
  });
};

export const useUpdateVegetable = () => {
  return useMutation({
    mutationFn: (payload) => updateVegetable(payload),
  });
};

// Groceries

export const useGetAllGrocery = () => {
  return useQuery({
    queryKey: ["All_Grocery"],
    queryFn: () => getAllGrocery(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },

  });
};

export const useAddGrocery = () => {
  return useMutation({
    mutationFn: (payload) => addGrocery(payload),
  });
};

export const useDeleteGrocery = () => {
  return useMutation({
    mutationFn: (payload) => deleteGrocery(payload),
  });
};

export const useUpdateGrocery = () => {
  return useMutation({
    mutationFn: (payload) => updateGrocery(payload),
  });
};

// DairyItems

export const useGetAllDairyItems = () => {
  return useQuery({
    queryKey: ["All_Dairyitems"],
    queryFn: () => getAllDairyItems(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },

  });
};

export const useAddDairyItems = () => {
  return useMutation({
    mutationFn: (payload) => addDairyItems(payload),
  });
};

export const useDeleteDairyItems = () => {
  return useMutation({
    mutationFn: (payload) => deleteDairyItems(payload),
  });
};

export const useUpdateDairyItems = () => {
  return useMutation({
    mutationFn: (payload) => updateDairyItems(payload),
  });
};



// FarsanItems

export const useGetAllFarsanItems = () => {
  return useQuery({
    queryKey: ["All_FarsanItems"],
    queryFn: () => getAllFarsanItems(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },

  });
};

export const useAddFarsanItems = () => {
  return useMutation({
    mutationFn: (payload) => addFarsanItems(payload),
  });
};

export const useDeleteFarsanItems = () => {
  return useMutation({
    mutationFn: (payload) => deleteFarsanItems(payload),
  });
};

export const useUpdateFarsanItems = () => {
  return useMutation({
    mutationFn: (payload) => updateFarsanItems(payload),
  });
};

// VasanItems

export const useGetAllVasanItems = () => {
  return useQuery({
    queryKey: ["All_VasanItems"],
    queryFn: () => getAllVasanItems(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },

  });
};

export const useAddVasanItems = () => {
  return useMutation({
    mutationFn: (payload) => addVasanItems(payload),
  });
};

export const useDeleteVasanItems = () => {
  return useMutation({
    mutationFn: (payload) => deleteVasanItems(payload),
  });
};

export const useUpdateVasanItems = () => {
  return useMutation({
    mutationFn: (payload) => updateVasanItems(payload),
  });
};

// MiscellaneousItems

export const useGetAllMiscellaneousItems = () => {
  return useQuery({
    queryKey: ["All_MiscellaneousItems"],
    queryFn: () => getAllMiscellaneousItems(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },

  });
};

export const useAddMiscellaneousItems = () => {
  return useMutation({
    mutationFn: (payload) => addMiscellaneousItems(payload),
  });
};

export const useDeleteMiscellaneousItems = () => {
  return useMutation({
    mutationFn: (payload) => deleteMiscellaneousItems(payload),
  });
};

export const useUpdateMiscellaneousItems = () => {
  return useMutation({
    mutationFn: (payload) => updateMiscellaneousItems(payload),
  });
};

export const useRegister = () => {
  return useMutation({
    mutationFn: (data) => register(data),
  });
};

export const useGetAllFarms = () => {
  return useQuery({
    queryKey: ["All_Farms"],
    queryFn: () => getFarms(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    }
  });
}

export const useDeleteFarm = () => {
  return useMutation({
    mutationFn: (payload) => deleteFarm(payload),
  });
}

export const useUpdateFarm = () => {
  return useMutation({
    mutationFn: (payload) => updateFarm(payload),
  });
}

export const useAddFarm = () => {
  return useMutation({
    mutationFn: (payload) => addFarm(payload),
  });
}

export const useAddCaterer = () => {
  return useMutation({
    mutationFn: (payload) => createCaterer(payload),
  });
}

export const useGetCatererById = (id, options = {}) => {
  return useQuery({
    queryKey: ["caterer", id],
    queryFn: () => getCatererById(id),
    enabled: !!id && (options.enabled ?? true),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },
  });
}

export const useUpdateCaterer = () => {
  return useMutation({
    mutationFn: ({ id, data }) => updateCaterer(id, data),
  });
}

export const useCreateSubscription = () => {
  return useMutation({
    mutationFn: (subscriptionData) => createSubscription(subscriptionData),
  });
}

export const useUpdateUserOnboardingStatus = () => {
  return useMutation({
    mutationFn: ({ userId, onboardingData }) => updateUserOnboardingStatus(userId, onboardingData),
  });
}


export const useGetAllsidemenu = () => {
  return useQuery({
    queryKey: ["all_side_menu"],
    queryFn: () => getAllsidemenu(),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },
  });
}

export const useGetSettings = (catererId) => {
  return useQuery({
    queryKey: ["settings", catererId],
    queryFn: () => getSettings(catererId),
    enabled: !!catererId,
    select: (response) => {
      const { data } = response;
      return data?.data;
    },
  });
};

// export const useUpdateSettings = () => {

//   return useMutation(
//     async (settingsData) => {
//       const { data } = await axios.post("/api/settings", settingsData);
//       return data;
//     },
//     {
//       onSuccess: () => {
//         // ✅ Refresh cached settings after update
//         queryClient.invalidateQueries(["settings"]);
//       },
//     }
//   );
// };

export const useUpdateSettings = () => {
   const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settingsData) => createSettings(settingsData),
    onSuccess: () => {
      queryClient.invalidateQueries(["settings"]);
    },
  });
}

// Custom hook to check onboarding status
export const useOnboardingStatus = () => {
  const [isOnboardingCompleted, setIsOnboardingCompleted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkOnboardingStatus = () => {
      try {
        const currentUser = JSON.parse(localStorage.getItem('CurrentUser') || '{}');
        const onboardingStatus = currentUser?.isOnboarding === true;
        setIsOnboardingCompleted(onboardingStatus);
      } catch (error) {
        console.error('Error parsing user data:', error);
        setIsOnboardingCompleted(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkOnboardingStatus();

    // Listen for storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'CurrentUser') {
        checkOnboardingStatus();
      }
    };

    // Listen for custom events
    const handleOnboardingComplete = () => {
      checkOnboardingStatus();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('onboardingComplete', handleOnboardingComplete);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('onboardingComplete', handleOnboardingComplete);
    };
  }, []);

  return { isOnboardingCompleted, isLoading };
};

export const useGetDashboardDataById = (id) => {
  return useQuery({
    queryKey: ["dashboard", id],
    queryFn: () => getDashboardData(id),
    select: (response) => {
      const { data } = response;
      return data?.data;
    },
  });
}

export const useUpdateUserLanguage = () => {
  return useMutation({
    mutationFn: ({ userId, preferredLanguage }) =>
      updateUserLanguage(userId, { preferredLanguage }),
  });
};
